import RequestPage from "./RequestPage";

const FiveYearReq = () => {
    return (
        <RequestPage title="Five year Request forms"
            fetchUrl="/get-five-year-requests"
            editEndpoint="edit-five-year-request"
            deleteEndpoint="five-year-request"
            statusEndpoint="five-year-request" />
    );
}

export default FiveYearReq;
